import { render, staticRenderFns } from "./ModalCourierBook.vue?vue&type=template&id=628b7507&"
import script from "./ModalCourierBook.vue?vue&type=script&lang=js&"
export * from "./ModalCourierBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports